/* ── Google Fonts ── */
const fontLink = document.createElement("link");
fontLink.rel = "stylesheet";
fontLink.href =
  "https://fonts.googleapis.com/css2?family=DM+Sans:opsz,wght@9..40,300;9..40,400;9..40,500;9..40,600;9..40,700&family=DM+Serif+Display&display=swap";
if (!document.head.querySelector('[href*="DM+Sans"]'))
  document.head.appendChild(fontLink);

export const FONT_UI      = "'DM Sans', 'Segoe UI', sans-serif";
export const FONT_HEADING = "'DM Serif Display', Georgia, serif";

export const API_BASE_URL  = "https://rfs1.react.eblackdog.net/api";
export const FALLBACK_LOGO = "../assets/image/eblackdog_logo.png";

/**
 * Each theme only needs: id, label, mode ('dark' | 'light'), accent (hex).
 * Everything else (faint/glow/border tints, bg, text colors) is DERIVED
 * from these two values inside Layout.jsx, so adding a theme is this simple.
 */
export const SKIN_THEMES = [
  { id: "navy",    label: "Navy",    mode: "dark",  accent: "#2563eb" },
  { id: "forest",  label: "Forest",  mode: "dark",  accent: "#16a34a" },
  { id: "crimson", label: "Crimson", mode: "dark",  accent: "#dc2626" },
  { id: "violet",  label: "Violet",  mode: "dark",  accent: "#7c3aed" },
  { id: "teal",    label: "Teal",    mode: "dark",  accent: "#0d9488" },
  { id: "amber",   label: "Amber",   mode: "dark",  accent: "#d97706" },
  { id: "slate",   label: "Slate",   mode: "dark",  accent: "#475569" },
  { id: "rose",    label: "Rose",    mode: "dark",  accent: "#e11d48" },
  // NEW
  { id: "onyx",    label: "Onyx",    mode: "dark",  accent: "#E5E7EB" }, // black/white theme (dark bg, light accent)
  { id: "snow",    label: "Snow",    mode: "light", accent: "#000000" }, // white bg, black text, black buttons
];

/** hex -> rgba helper, used to derive glow/border/faint tints from one accent color */
export function hexToRgba(hex, alpha) {
  const h = hex.replace("#", "");
  const bigint = parseInt(
    h.length === 3 ? h.split("").map((c) => c + c).join("") : h,
    16
  );
  const r = (bigint >> 16) & 255;
  const g = (bigint >> 8) & 255;
  const b = bigint & 255;
  return `rgba(${r}, ${g}, ${b}, ${alpha})`;
}

/** Builds the full CSS variable map for a given theme. */
export function getThemeVars(skin) {
  const isLight = skin.mode === "light";
  const accent = skin.accent;
  const isOnyx = skin.id === "onyx";

  return {
    "--accent":        accent,
    "--accent-glow":   hexToRgba(accent, isLight ? 0.12 : 0.18),
    "--accent-border": hexToRgba(accent, isLight ? 0.35 : 0.30),
    "--accent-faint":  hexToRgba(accent, isLight ? 0.07 : 0.08),

    "--page-bg":       isLight ? "#FFFFFF" : "#111111",
    "--card-bg":       isLight ? "#FFFFFF" : "#1A1A1A",
    "--card-border":   isLight ? "#E5E7EB" : "#2A2A2A",
    "--surface":       isLight ? "#F3F4F6" : "#222222",
    "--surface-border":isLight ? "#E5E7EB" : "#2E2E2E",
    "--sidebar-bg":    isLight ? "#FAFAFA" : "#161616",
    "--sidebar-top":   isLight ? "#FFFFFF" : "#1A1A1A",
    "--divider":       isLight ? "#E5E7EB" : "#2A2A2A",

    "--text-primary":  isLight ? "#111111" : "#F3F4F6",
    "--text-sub":      isLight ? "#374151" : "#9CA3AF",
    "--text-muted":    isLight ? "#6B7280" : "#6B7280",
    "--text-faint":    isLight ? "#9CA3AF" : "#4B5563",

    /* Buttons:
       - snow  → black bg + white text
       - onyx  → black bg + light text  (prevents white-on-light-gray)
       - others → accent bg + white text
    */
    "--btn-bg":   isLight || isOnyx ? "#000000" : accent,
    "--btn-text": isOnyx ? "#E5E7EB" : "#FFFFFF",

    "--red":       "#F87171",
    "--red-faint": "rgba(239,68,68,0.08)",
    "--red-border":"rgba(239,68,68,0.25)",
  };
}